import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getConsolidationManifestCsv = {
  name: "getConsolidationManifestCsv" as const,
  input: z.object({ consolidationId: consolidationIdFormat.schema }),
  output: z.object({ url: z.string() }),
};
